const CASHBACK_REGEX = /cash\s*-?\s*back/gi;

function sanitizeCashbackLabel(value) {
  if (typeof value !== "string") {
    return value;
  }

  return value
    .replace(/cr[eé]dito\s*\/\s*cash\s*-?\s*back/gi, "credito")
    .replace(CASHBACK_REGEX, "credito");
}

function replaceCashbackMentions(rootElement) {
  if (!rootElement || typeof NodeFilter === "undefined") {
    return;
  }

  const textWalker = document.createTreeWalker(rootElement, NodeFilter.SHOW_TEXT, null, false);
  const textNodes = [];

  while (textWalker.nextNode()) {
    textNodes.push(textWalker.currentNode);
  }

  textNodes.forEach((textNode) => {
    const parentTag = textNode.parentElement && textNode.parentElement.tagName;
    if (!parentTag || parentTag === "SCRIPT" || parentTag === "STYLE") {
      return;
    }

    const originalText = textNode.nodeValue;
    const sanitizedText = sanitizeCashbackLabel(originalText);
    if (originalText !== sanitizedText) {
      textNode.nodeValue = sanitizedText;
    }
  });

  const attrSelectors = ["[title]", "[aria-label]", "[placeholder]"];
  rootElement.querySelectorAll(attrSelectors.join(",")).forEach((element) => {
    ["title", "aria-label", "placeholder"].forEach((attrName) => {
      const attrValue = element.getAttribute(attrName);
      if (!attrValue) {
        return;
      }

      const sanitizedValue = sanitizeCashbackLabel(attrValue);
      if (sanitizedValue !== attrValue) {
        element.setAttribute(attrName, sanitizedValue);
      }
    });
  });
}

function getColumnChildren(rowElement) {
  return Array.from(rowElement.children).filter((child) => {
    return child.className && child.className.indexOf("col") >= 0;
  });
}

function getListButtonColumn(columns) {
  return columns.find((column) => {
    if (column.querySelector("#btlistar")) {
      return true;
    }

    const actionButton = column.querySelector("button, a");
    return actionButton && /listar/i.test((actionButton.textContent || "").trim());
  });
}

function getCreateButtonColumn(columns) {
  return columns.find((column) => {
    const actionButton = column.querySelector("button, a");
    return actionButton && /novo|incluir|adicionar|criar/i.test((actionButton.textContent || "").trim());
  });
}

function getExistingMoreButtonColumn(columns) {
  return columns.find((column) => {
    return column.querySelector("#btmaisfiltros") || column.querySelector("[data-draco-more-filters='1']");
  });
}

function createMoreFiltersColumn() {
  const moreColumn = document.createElement("div");
  moreColumn.className = "col-6 col-sm-6 col-md-2 col-lg-2";
  moreColumn.setAttribute("data-draco-more-filters", "1");

  const button = document.createElement("button");
  button.type = "button";
  button.className = "btn btn-secondary btn-sm btn-block crud-more-filters-btn";
  button.setAttribute("data-draco-more-label", "Mais filtros");
  button.innerHTML = "<i class='fa fa-sliders'></i>";

  moreColumn.appendChild(button);
  return moreColumn;
}

function buildBaseCard(role, ownerKey) {
  const card = document.createElement("div");
  card.className = `card mb-3 ${role}`;
  card.setAttribute("data-draco-owner", ownerKey);

  const cardBody = document.createElement("div");
  cardBody.className = "card-body";
  card.appendChild(cardBody);

  return { card, cardBody };
}

function ensureOwnerKey(listCardElement) {
  if (!listCardElement.dataset.dracoOwner) {
    listCardElement.dataset.dracoOwner = `crud-${Date.now()}-${Math.floor(Math.random() * 100000)}`;
  }

  return listCardElement.dataset.dracoOwner;
}

function findByRole(ownerParentElement, ownerKey, roleClass) {
  return Array.from(ownerParentElement.children).find((child) => {
    return child.classList && child.classList.contains(roleClass) && child.getAttribute("data-draco-owner") === ownerKey;
  });
}

function findOriginalNewButton(listCardElement, ownerParent) {
  const matchesCreateText = (element) => {
    return /novo|incluir|adicionar|criar/i.test((element.textContent || "").trim());
  };

  const isBlocked = (element) => {
    if (!element) {
      return true;
    }
    if (element.matches("[data-draco-top-new='1']")) {
      return true;
    }
    if (element.closest(".crud-breadcrumb-action, .crud-action-card")) {
      return true;
    }
    const blockedContainer = element.closest(".dropdown-menu, .modal-footer, .card-footer, table, .vue-bootstrap4-table");
    return !!blockedContainer;
  };

  const cardFooter = listCardElement.querySelector(".card-footer");
  const fromFooter = cardFooter
    ? Array.from(cardFooter.querySelectorAll("button, a")).find((element) => {
      return matchesCreateText(element);
    })
    : null;
  if (fromFooter) {
    return fromFooter;
  }

  const listCardBody = listCardElement.querySelector(".card-body");
  if (listCardBody) {
    const fromListBody = Array.from(listCardBody.querySelectorAll("button, a")).find((element) => {
      return matchesCreateText(element) && !isBlocked(element);
    });
    if (fromListBody) {
      return fromListBody;
    }
  }

  if (ownerParent) {
    const fromOwner = Array.from(ownerParent.querySelectorAll("button, a")).find((element) => {
      return matchesCreateText(element) && !isBlocked(element);
    });
    if (fromOwner) {
      return fromOwner;
    }
  }

  return null;
}

function isCrudListVisible(listCardElement) {
  if (!listCardElement) {
    return false;
  }
  return window.getComputedStyle(listCardElement).display !== "none";
}

function triggerCrudCancelEdit(crudContainerElement) {
  if (!crudContainerElement) {
    return false;
  }

  const breadcrumbEditLink = Array.from(crudContainerElement.querySelectorAll(".crud-breadcrumb a")).find((anchor) => {
    const text = (anchor.textContent || "").trim().toLowerCase();
    return text !== "" && text !== "principal";
  });
  if (breadcrumbEditLink) {
    breadcrumbEditLink.click();
    return true;
  }

  const closeButton = crudContainerElement.querySelector("#pncadastro .card-header .close, #pnentregaexterna .card-header .close, #pnconferencia .card-header .close");
  if (closeButton) {
    closeButton.click();
    return true;
  }

  const footerCancelButton = Array.from(crudContainerElement.querySelectorAll("#pncadastro .card-footer button, #pncadastro .card-footer a"))
    .find((element) => {
      const label = (element.textContent || "").trim().toLowerCase();
      if (label === "") {
        return false;
      }
      return /fechar|voltar|cancelar/.test(label);
    });
  if (footerCancelButton) {
    footerCancelButton.click();
    return true;
  }

  return false;
}

function syncTopButtonContent(targetButton, originalNewButton, listVisible) {
  if (!targetButton) {
    return;
  }

  if (listVisible) {
    targetButton.className = `${(originalNewButton && originalNewButton.className) || "btn btn-success"} crud-top-new-btn`;
    targetButton.className = targetButton.className.replace(/\s*btn-block\s*/g, " ").trim();
    targetButton.innerHTML = (originalNewButton && originalNewButton.innerHTML) || "<i class='fa fa-file'></i> Criar";
    if ((targetButton.textContent || "").trim() === "") {
      targetButton.innerHTML = "<i class='fa fa-file'></i> Criar";
    }
    targetButton.__dracoMode = "create";
    targetButton.setAttribute("data-draco-mode", "create");
  } else {
    targetButton.className = "btn btn-danger btn-sm crud-top-new-btn";
    targetButton.innerHTML = "<i class='fa fa-reply'></i> Voltar";
    targetButton.__dracoMode = "back";
    targetButton.setAttribute("data-draco-mode", "back");
  }

  targetButton.type = "button";
  targetButton.__dracoOriginalNewButton = originalNewButton;

  if (!targetButton.__dracoClickHandler) {
    targetButton.__dracoClickHandler = (event) => {
      event.preventDefault();
      if (targetButton.__dracoMode === "back") {
        triggerCrudCancelEdit(targetButton.__dracoCrudContainer);
        return;
      }
      if (targetButton.__dracoOriginalNewButton) {
        targetButton.__dracoOriginalNewButton.click();
      }
    };
    targetButton.addEventListener("click", targetButton.__dracoClickHandler);
  }
}

function toSentenceCase(value) {
  if (typeof value !== "string") {
    return "";
  }
  const normalized = value.replace(/\s+/g, " ").trim();
  if (!normalized) {
    return "";
  }
  return normalized
    .toLocaleLowerCase("pt-BR")
    .replace(/(^|\s)(\S)/gu, (match, prefix, char) => `${prefix}${char.toLocaleUpperCase("pt-BR")}`);
}

function resolveBreadcrumbParts(crudContainerElement) {
  const breadcrumbItems = Array.from(crudContainerElement.querySelectorAll(".breadcrumb .breadcrumb-item"));
  const labels = breadcrumbItems
    .map((item) => (item.textContent || "").replace(/\s+/g, " ").trim())
    .filter((label) => label !== "");

  if (!labels.length) {
    return {
      title: "",
      subtitle: ""
    };
  }

  const title = labels[labels.length - 1];
  const subtitle = labels.join(" / ");
  return { title, subtitle };
}

function resolveListTitle(listCardElement) {
  if (!listCardElement) {
    return "";
  }
  const titleElement = listCardElement.querySelector("#titlista");
  if (!titleElement) {
    return "";
  }
  return (titleElement.textContent || "")
    .replace(/painel\s+de\s+/i, "")
    .replace(/\s+/g, " ")
    .trim();
}

function ensureTopHeader(crudContainerElement, listCardElement, originalNewButton, listVisible) {
  if (!crudContainerElement) {
    return false;
  }

  const breadcrumbNav = crudContainerElement.querySelector(".crud-breadcrumb-nav, nav[aria-label='breadcrumb']");
  if (breadcrumbNav) {
    breadcrumbNav.classList.add("crud-breadcrumb-hidden");
  }

  let topHeader = crudContainerElement.querySelector("[data-draco-top-header='1']");
  if (!topHeader) {
    topHeader = document.createElement("div");
    topHeader.className = "crud-top-header-shell";
    topHeader.setAttribute("data-draco-top-header", "1");
    topHeader.innerHTML = `
      <div class="crud-top-header-main">
        <span class="crud-top-header-kicker">Operações do módulo</span>
        <h5 class="crud-top-header-title"></h5>
        <p class="crud-top-header-subtitle"></p>
      </div>
      <div class="crud-top-header-actions" data-draco-breadcrumb-action="1"></div>
    `;

    if (breadcrumbNav && breadcrumbNav.parentElement) {
      breadcrumbNav.parentElement.insertBefore(topHeader, breadcrumbNav.nextSibling);
    } else {
      crudContainerElement.insertBefore(topHeader, crudContainerElement.firstChild);
    }
  }

  const breadcrumbParts = resolveBreadcrumbParts(crudContainerElement);
  const listTitle = resolveListTitle(listCardElement);
  const rawTitle = listTitle || breadcrumbParts.title || "Cadastro";
  const rawSubtitle = breadcrumbParts.subtitle || `Principal / ${rawTitle}`;

  const kickerElement = topHeader.querySelector(".crud-top-header-kicker");
  const titleElement = topHeader.querySelector(".crud-top-header-title");
  const subtitleElement = topHeader.querySelector(".crud-top-header-subtitle");

  if (kickerElement) {
    kickerElement.textContent = "Operações do módulo";
  }
  if (titleElement) {
    titleElement.textContent = toSentenceCase(rawTitle);
  }
  if (subtitleElement) {
    subtitleElement.textContent = toSentenceCase(rawSubtitle);
  }

  let actionWrap = topHeader.querySelector("[data-draco-breadcrumb-action='1']");
  if (!actionWrap) {
    actionWrap = document.createElement("div");
    actionWrap.className = "crud-top-header-actions";
    actionWrap.setAttribute("data-draco-breadcrumb-action", "1");
    topHeader.appendChild(actionWrap);
  }

  let topNewButton = actionWrap.querySelector("[data-draco-top-new='1']");
  if (!topNewButton) {
    topNewButton = document.createElement("button");
    topNewButton.setAttribute("data-draco-top-new", "1");
    actionWrap.appendChild(topNewButton);
  }

  topNewButton.__dracoCrudContainer = crudContainerElement;
  syncTopButtonContent(topNewButton, originalNewButton, listVisible);
  return true;
}

function clearBreadcrumbAction(crudContainerElement) {
  if (!crudContainerElement) {
    return;
  }
  const actionWrap = crudContainerElement.querySelector("[data-draco-breadcrumb-action='1']");
  if (actionWrap) {
    actionWrap.remove();
  }
}

function ensureActionCard(listCardElement, ownerKey) {
  const ownerParent = listCardElement.parentElement;
  if (!ownerParent) {
    return null;
  }
  const crudContainer = resolveCrudContainerFromListCard(listCardElement);
  let originalNewButton = findOriginalNewButton(listCardElement, ownerParent);
  if (originalNewButton) {
    listCardElement.__dracoOriginalNewButton = originalNewButton;
  } else if (listCardElement.__dracoOriginalNewButton) {
    originalNewButton = listCardElement.__dracoOriginalNewButton;
  }
  const listVisible = isCrudListVisible(listCardElement);

  let actionCard = findByRole(ownerParent, ownerKey, "crud-action-card");

  if (!originalNewButton && listVisible) {
    listCardElement.querySelectorAll(".crud-original-new-hidden").forEach((column) => {
      column.classList.remove("crud-original-new-hidden");
      column.style.removeProperty("display");
    });
    clearBreadcrumbAction(crudContainer);
    if (actionCard) {
      actionCard.remove();
    }
    return null;
  }

  if (!originalNewButton && !listVisible) {
    originalNewButton = {
      className: "btn btn-success btn-sm",
      innerHTML: "<i class='fa fa-file'></i> Criar",
      click: () => {}
    };
  }

  const usingBreadcrumbAction = ensureTopHeader(crudContainer, listCardElement, originalNewButton, listVisible);
  if (usingBreadcrumbAction && actionCard) {
    actionCard.remove();
    actionCard = null;
  }

  if (!usingBreadcrumbAction && !actionCard) {
    const built = buildBaseCard("crud-action-card", ownerKey);
    actionCard = built.card;
    ownerParent.insertBefore(actionCard, listCardElement);
  }

  if (usingBreadcrumbAction) {
    const originalButtonColumn = originalNewButton.closest("[class*='col-']") || originalNewButton.parentElement;
    if (originalButtonColumn) {
      originalButtonColumn.classList.add("crud-original-new-hidden");
      originalButtonColumn.style.display = "none";
    }
    return null;
  }

  const actionCardBody = actionCard.querySelector(".card-body");
  if (!actionCardBody) {
    return actionCard;
  }

  let topNewButton = actionCardBody.querySelector("[data-draco-top-new='1']");
  if (!topNewButton) {
    actionCardBody.innerHTML = "";
    topNewButton = document.createElement("button");
    topNewButton.setAttribute("data-draco-top-new", "1");
    actionCardBody.appendChild(topNewButton);
  }

  syncTopButtonContent(topNewButton, originalNewButton);
  const originalButtonColumn = originalNewButton.closest("[class*='col-']") || originalNewButton.parentElement;
  if (originalButtonColumn) {
    originalButtonColumn.classList.add("crud-original-new-hidden");
    originalButtonColumn.style.display = "none";
  }

  return actionCard;
}

function detectTableStartIndex(columns) {
  let tableIndex = columns.findIndex((column) => {
    return column.querySelector("table") ||
      column.querySelector(".table-responsive") ||
      column.querySelector(".vue-bootstrap4-table") ||
      column.querySelector("[class*='easy-data-table']");
  });

  if (tableIndex >= 0) {
    return tableIndex;
  }

  tableIndex = columns.findIndex((column) => {
    const styleValue = column.getAttribute("style") || "";
    return styleValue.indexOf("margin-top") >= 0;
  });

  return tableIndex;
}

function configureMoreFilters(filtersGrid, searchCardElement) {
  const columns = getColumnChildren(filtersGrid);
  const listButtonColumn = getListButtonColumn(columns);
  const createButtonColumn = getCreateButtonColumn(columns);
  const existingMoreColumn = getExistingMoreButtonColumn(columns);

  if (existingMoreColumn) {
    const existingMoreButton = existingMoreColumn.querySelector("button, a");
    if (existingMoreButton) {
      existingMoreButton.classList.add("crud-more-filters-btn");
      existingMoreButton.setAttribute("data-draco-more-label", "Mais filtros");
      existingMoreButton.addEventListener("click", () => {
        const isCollapsed = searchCardElement.classList.toggle("crud-filters-collapsed");
        existingMoreButton.setAttribute("data-draco-more-label", isCollapsed ? "Mais filtros" : "Menos filtros");
      });
    }
    return;
  }

  const plainFilterColumns = columns.filter((column) => {
    return column !== listButtonColumn && column !== createButtonColumn;
  });

  if (plainFilterColumns.length <= 4) {
    return;
  }

  plainFilterColumns.forEach((column, index) => {
    if (index >= 4) {
      column.classList.add("crud-filter-extra");
    }
  });

  searchCardElement.classList.add("crud-filters-collapsed");

  const generatedMoreColumn = createMoreFiltersColumn();
  if (createButtonColumn) {
    filtersGrid.insertBefore(generatedMoreColumn, createButtonColumn);
  } else if (listButtonColumn) {
    filtersGrid.insertBefore(generatedMoreColumn, listButtonColumn);
  } else {
    filtersGrid.appendChild(generatedMoreColumn);
  }

  const generatedMoreButton = generatedMoreColumn.querySelector("button");
  if (generatedMoreButton) {
    generatedMoreButton.addEventListener("click", () => {
      const isCollapsed = searchCardElement.classList.toggle("crud-filters-collapsed");
      generatedMoreButton.setAttribute("data-draco-more-label", isCollapsed ? "Mais filtros" : "Menos filtros");
    });
  }
}

function ensureSearchCard(listCardElement, ownerKey) {
  const ownerParent = listCardElement.parentElement;
  if (!ownerParent) {
    return null;
  }

  let searchCard = findByRole(ownerParent, ownerKey, "crud-search-card");
  if (!searchCard) {
    const built = buildBaseCard("crud-search-card", ownerKey);
    searchCard = built.card;

    const actionCard = findByRole(ownerParent, ownerKey, "crud-action-card");
    if (actionCard && actionCard.nextSibling) {
      ownerParent.insertBefore(searchCard, actionCard.nextSibling);
    } else {
      ownerParent.insertBefore(searchCard, listCardElement);
    }
  }

  if (searchCard.dataset.dracoFiltersReady === "1") {
    return searchCard;
  }

  const cardBody = listCardElement.querySelector(".card-body");
  if (!cardBody) {
    return searchCard;
  }

  const firstRow = cardBody.querySelector(".row");
  if (!firstRow) {
    return searchCard;
  }

  const allColumns = getColumnChildren(firstRow);
  if (allColumns.length < 4) {
    return searchCard;
  }

  const tableColumnIndex = detectTableStartIndex(allColumns);
  if (tableColumnIndex <= 0) {
    return searchCard;
  }

  const filterColumns = allColumns.slice(0, tableColumnIndex);
  if (filterColumns.length < 3) {
    return searchCard;
  }

  const searchCardBody = searchCard.querySelector(".card-body");
  if (!searchCardBody) {
    return searchCard;
  }

  const filtersGrid = document.createElement("div");
  filtersGrid.className = "row crud-filters-grid";

  filterColumns.forEach((column) => {
    filtersGrid.appendChild(column);
    column.classList.add("crud-filter-item");
  });

  searchCardBody.appendChild(filtersGrid);
  configureMoreFilters(filtersGrid, searchCard);
  searchCard.dataset.dracoFiltersReady = "1";

  return searchCard;
}

function normalizeLabel(value) {
  return (value || "")
    .toString()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();
}

function isLikelyTotalizer(label) {
  return /(total|vencid|a vencer|juros|multa|desconto|selecionad|soma|cancelad|aberto|faturad|custo|cashback|recebid|pago|entrad|saida|diferenc|parcela)/.test(label);
}

function findLabelIndex(labels, terms) {
  return labels.findIndex((label) => {
    return terms.some((term) => label.indexOf(term) >= 0);
  });
}

function resolvePrimaryIndexes(entries) {
  const labels = entries.map((entry) => normalizeLabel(entry.item.textContent));
  const preferredIndexes = [];

  const totalFaturadoIndex = findLabelIndex(labels, ["total faturado"]);
  const totalCustoIndex = findLabelIndex(labels, ["total custo"]);
  if (totalFaturadoIndex >= 0 && totalCustoIndex >= 0) {
    preferredIndexes.push(totalFaturadoIndex, totalCustoIndex);
  } else {
    const totalPagarIndex = findLabelIndex(labels, ["total geral a pagar", "total a pagar"]);
    const somaTitulosIndex = findLabelIndex(labels, ["soma dos titulos", "soma titulos", "soma rtitulo", "rtitulo"]);
    if (totalPagarIndex >= 0 && somaTitulosIndex >= 0) {
      preferredIndexes.push(totalPagarIndex, somaTitulosIndex);
    }
  }

  const uniquePreferred = [];
  preferredIndexes.forEach((index) => {
    if (index >= 0 && !uniquePreferred.includes(index)) {
      uniquePreferred.push(index);
    }
  });

  for (let index = 0; uniquePreferred.length < Math.min(entries.length, 2); index += 1) {
    if (!uniquePreferred.includes(index)) {
      uniquePreferred.push(index);
    }
  }

  return uniquePreferred;
}

function createMoreTotalizersControl(ownerElement) {
  const wrapper = document.createElement("div");
  wrapper.className = "crud-totalizers-toggle-wrap";
  wrapper.setAttribute("data-draco-more-totalizers", "1");

  const button = document.createElement("button");
  button.type = "button";
  button.className = "btn btn-link btn-sm crud-more-totalizers-btn";

  const syncLabel = () => {
    const isExpanded = ownerElement.classList.contains("crud-totalizers-expanded");
    button.innerHTML = isExpanded
      ? "<i class='fa fa-minus'></i> Menos"
      : "<i class='fa fa-plus'></i> Mais";
  };

  button.addEventListener("click", () => {
    ownerElement.classList.toggle("crud-totalizers-expanded");
    syncLabel();
  });

  syncLabel();
  wrapper.appendChild(button);
  return wrapper;
}

function applyTotalizerCollapse(ownerElement, entries, insertAfterElement) {
  if (!ownerElement || ownerElement.dataset.dracoTotalsReady === "1") {
    return;
  }

  if (!entries || entries.length <= 2) {
    return;
  }

  const labels = entries.map((entry) => normalizeLabel(entry.item.textContent));
  const likelyTotalizers = labels.filter((label) => isLikelyTotalizer(label));
  if (likelyTotalizers.length < 2) {
    return;
  }

  const primaryIndexes = resolvePrimaryIndexes(entries);
  const extraEntries = entries.filter((entry, index) => !primaryIndexes.includes(index));
  if (!extraEntries.length) {
    return;
  }

  extraEntries.forEach((entry) => {
    entry.host.classList.add("crud-totalizer-extra");
  });

  ownerElement.classList.add("crud-totalizers-collapsed");

  const control = createMoreTotalizersControl(ownerElement);
  if (insertAfterElement && insertAfterElement.parentElement) {
    insertAfterElement.parentElement.insertBefore(control, insertAfterElement.nextSibling);
  } else {
    ownerElement.appendChild(control);
  }

  ownerElement.dataset.dracoTotalsReady = "1";
}

function enhanceTotalizerGroups(listCardElement) {
  const listGroups = Array.from(listCardElement.querySelectorAll(".list-group")).filter((group) => {
    return group.closest("#pnlista") === listCardElement;
  });

  listGroups.forEach((group) => {
    const items = Array.from(group.children).filter((child) => {
      return child.classList && (child.classList.contains("lstdettot") || child.classList.contains("lstdetrec"));
    });

    if (items.length <= 2) {
      return;
    }

    const entries = items.map((item) => ({
      host: item,
      item
    }));

    applyTotalizerCollapse(group, entries, group);
  });
}

function enhanceTotalizerRows(listCardElement) {
  const rows = Array.from(listCardElement.querySelectorAll(".row")).filter((row) => {
    return row.closest("#pnlista") === listCardElement;
  });

  rows.forEach((row) => {
    if (row.querySelector("table, .vue-bootstrap4-table")) {
      return;
    }

    const columns = getColumnChildren(row);
    const totalizerColumns = columns.filter((column) => {
      return column.querySelector(".lstdettot, .lstdetrec");
    });

    if (totalizerColumns.length <= 2) {
      return;
    }

    const entries = totalizerColumns.map((column) => ({
      host: column,
      item: column.querySelector(".lstdettot, .lstdetrec")
    })).filter((entry) => entry.item);

    applyTotalizerCollapse(row, entries, row);
  });
}

function hideRegisterCountRow(listCardElement) {
  const badges = Array.from(listCardElement.querySelectorAll(".bdg-qtd-reg-info"));
  badges.forEach((badge) => {
    const rowItem = badge.closest("li, a");
    if (!rowItem || rowItem.dataset.dracoRegisterHidden === "1") {
      return;
    }

    const rowLabel = normalizeLabel(rowItem.textContent || "");
    if (rowLabel.indexOf("registros") !== 0) {
      return;
    }

    const parentColumn = rowItem.closest("[class*='col-']");
    if (parentColumn && parentColumn.closest("#pnlista") === listCardElement) {
      parentColumn.classList.add("crud-register-count-hidden");
    } else {
      rowItem.classList.add("crud-register-count-hidden");
    }

    rowItem.dataset.dracoRegisterHidden = "1";
  });
}

function enhanceTotalizers(listCardElement) {
  if (!listCardElement) {
    return;
  }

  hideRegisterCountRow(listCardElement);
  enhanceTotalizerRows(listCardElement);
  enhanceTotalizerGroups(listCardElement);
}

function enhanceBreadcrumb(crudContainerElement) {
  const breadcrumbNav = crudContainerElement.querySelector(".crud-breadcrumb-nav, nav[aria-label='breadcrumb']");
  if (breadcrumbNav) {
    breadcrumbNav.classList.add("crud-breadcrumb-nav");
  }

  const breadcrumb = crudContainerElement.querySelector(".breadcrumb");
  if (breadcrumb) {
    breadcrumb.classList.add("crud-breadcrumb");
  }
}

function syncAuxVisibility(listCardElement, actionCardElement, searchCardElement) {
  const isListVisible = window.getComputedStyle(listCardElement).display !== "none";

  if (actionCardElement) {
    actionCardElement.style.display = isListVisible ? "" : "none";
  }

  if (searchCardElement) {
    searchCardElement.style.display = isListVisible ? "" : "none";
  }
}

function resolveCrudContainerFromListCard(listCardElement) {
  if (!listCardElement) {
    return null;
  }

  return listCardElement.closest("#dvcrud") || listCardElement.closest(".container-fluid") || listCardElement.parentElement;
}

function enhanceCrudContainer(crudContainerElement, forcedListCardElement = null) {
  if (!crudContainerElement) {
    return;
  }

  crudContainerElement.classList.add("crud-layout-root");
  enhanceBreadcrumb(crudContainerElement);

  const listCard = forcedListCardElement || crudContainerElement.querySelector("#pnlista.card");
  if (!listCard) {
    return;
  }

  listCard.classList.add("crud-list-card");
  listCard.classList.add("draco-parentless-card");

  const ownerKey = ensureOwnerKey(listCard);
  const actionCard = ensureActionCard(listCard, ownerKey);
  const searchCard = ensureSearchCard(listCard, ownerKey);
  syncAuxVisibility(listCard, actionCard, searchCard);
  enhanceTotalizers(listCard);
  crudContainerElement.classList.add("crud-layout-ready");
}

let enhanceTimer = null;
let observerInitialized = false;
const requestFrame = typeof window !== "undefined" && typeof window.requestAnimationFrame === "function"
  ? window.requestAnimationFrame.bind(window)
  : (callback) => setTimeout(callback, 0);
const cancelFrame = typeof window !== "undefined" && typeof window.cancelAnimationFrame === "function"
  ? window.cancelAnimationFrame.bind(window)
  : clearTimeout;

function scheduleEnhancement() {
  if (enhanceTimer !== null) {
    cancelFrame(enhanceTimer);
  }

  enhanceTimer = requestFrame(() => {
    enhanceTimer = null;

    const handledListCards = new Set();

    const crudContainers = document.querySelectorAll("#dvcrud");
    crudContainers.forEach((crudContainer) => {
      const listCard = crudContainer.querySelector("#pnlista.card");
      if (listCard) {
        handledListCards.add(listCard);
      }
      enhanceCrudContainer(crudContainer, listCard);
    });

    const orphanListCards = document.querySelectorAll("#pnlista.card");
    orphanListCards.forEach((listCard) => {
      if (handledListCards.has(listCard)) {
        return;
      }

      const fallbackContainer = resolveCrudContainerFromListCard(listCard);
      if (fallbackContainer) {
        enhanceCrudContainer(fallbackContainer, listCard);
      }
    });

  });
}

function initMutationObserver() {
  if (observerInitialized || typeof MutationObserver === "undefined") {
    return;
  }

  observerInitialized = true;
  const observer = new MutationObserver(() => {
    scheduleEnhancement();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["style", "class"]
  });
}

const CrudLayoutBridge = {
  install(Vue) {
    Vue.mixin({
      mounted() {
        scheduleEnhancement();
        initMutationObserver();
      },
      updated() {
        scheduleEnhancement();
      }
    });
  }
};

export default CrudLayoutBridge;





